function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSpotify = function SvgIconSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm3.898 12.26a.53.53 0 0 1-.729.175c-1.995-1.219-4.508-1.495-7.467-.819a.53.53 0 0 1-.235-1.033c3.237-.74 6.015-.422 8.255.948a.53.53 0 0 1 .176.728Zm1.04-2.315a.662.662 0 0 1-.911.219c-2.285-1.405-5.768-1.812-8.47-.992a.664.664 0 0 1-.385-1.268c3.087-.936 6.924-.483 9.548 1.13.312.192.41.6.218.91Zm.09-2.41c-2.74-1.628-7.26-1.777-9.875-.983A.795.795 0 1 1 6.69 8.53c3.003-.911 7.994-.735 11.148 1.137a.794.794 0 1 1-.81 1.368h-.001Z"
  }));
};
export default SvgIconSpotify;